import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4"
        >
          <div className="max-w-7xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-6 md:flex md:items-center md:justify-between relative">
              <button
                onClick={() => setIsVisible(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
              
              <div className="flex items-start md:items-center space-x-4 mb-4 md:mb-0 pr-8">
                <Cookie className="h-6 w-6 text-gray-400 flex-shrink-0" />
                <div className="flex-grow">
                  <p className="text-sm text-gray-600">
                    We use cookies to enhance your experience and analyze our website traffic. 
                    By clicking "Accept", you consent to our use of cookies. For more information, 
                    please read our{' '}
                    <Link
                      to="/privacy-policy"
                      className="text-indigo-600 hover:text-indigo-800 underline"
                      onClick={() => setIsVisible(false)}
                    >
                      Privacy Policy
                    </Link>
                    .
                  </p>
                </div>
              </div>
              
              <div className="flex space-x-4">
                <button
                  onClick={handleDecline}
                  className="text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Decline
                </button>
                <button
                  onClick={handleAccept}
                  className="px-4 py-2 text-sm font-medium text-white rounded-md transition-colors"
                  style={{ backgroundColor: '#C1B3A3' }}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;